export default __webpack_public_path__ + "static/media/logout.17b9b075.svg";